module.exports = __webpack_public_path__ + "img/xmps-img.c15462f3.png";